import { FileClient, UploadFilesResponse, UploadedFile } from "@infrastructure/clients/http/clients/file.client";
import { ServiceClient, CalculatePriceRequest, CalculatePriceResponse, ServiceCalculateResponse } from "@infrastructure/clients/http/clients/service.client";
import { catchError } from "@shared/utils/errors/catchError";
import { trackFunnel } from "@shared/utils/analytics";
import { AuthStore } from "@infrastructure/stores/auth.store";

/**
 * Domain сервис для работы с файлами
 * Инкапсулирует работу с FileClient и ServiceClient
 */
class FileServiceClass {
  /**
   * Загружает файлы на сервер
   * @returns Массив загруженных файлов
   */
  async uploadFiles(files: File[]): Promise<UploadedFile[]> {
    const fileClient = new FileClient();
    const [error, result] = await catchError(fileClient.uploadFiles(files));
    
    if (error) {
      throw error;
    }
    
    // FileClient возвращает { data: UploadFilesResponse }
    // UploadFilesResponse имеет структуру: { status, data: { files: [...] }, details }
    const uploaded = result.data.data.files || [];
    if (uploaded.length) {
      trackFunnel("file_uploaded", AuthStore.user?.id ?? null, {
        count: uploaded.length,
      });
    }
    return uploaded;
  }

  /**
   * Рассчитывает цену для услуги (старая ручка)
   */
  async calculatePrice(requestData: CalculatePriceRequest): Promise<CalculatePriceResponse> {
    const serviceClient = new ServiceClient();
    const [error, result] = await catchError(serviceClient.getServiceCalculatePrice(requestData));
    
    if (error) {
      throw error;
    }
    
    // ServiceClient возвращает { data: CalculatePriceResponse }
    return result.data;
  }

  /**
   * Рассчитывает цену для услуги с проверкой ресурсов и промокодов (новая ручка)
   */
  async calculatePriceWithValidation(requestData: CalculatePriceRequest): Promise<ServiceCalculateResponse> {
    const serviceClient = new ServiceClient();
    const [error, result] = await catchError(serviceClient.getServiceCalculatePriceWithValidation(requestData));
    
    if (error) {
      throw error;
    }
    
    // ServiceClient возвращает { data: ServiceCalculateResponse }
    return result.data;
  }
}

export const FileService = new FileServiceClass();

